import { ROUTE_IDS } from '../experience/routes/ids.js';
const PLATFORM_PERSONAS = new Set(['PLATFORM_ROOT', 'PLATFORM_ADMIN', 'PLATFORM_USER']);
const ORGANIZATION_PERSONAS = new Set(['ORG_ADMIN', 'ORG_USER', 'ORG_CLIENT', 'SUPPORT_DELEGATE']);
/**
 * Branch is an internal authorization/accounting scope in the single-Organization
 * artifact. Context switching remains supported by auth, but Branch CRUD pages
 * are intentionally not shipped in the Organization Runtime web manifest.
 * Combined/dev builds retain them for controlled development and future rollout.
 */
const ORGANIZATION_RUNTIME_HIDDEN_ROUTE_IDS = new Set([
    ROUTE_IDS.ORGANIZATION_BRANCHES_LIST,
    ROUTE_IDS.ORGANIZATION_BRANCHES_CREATE,
    ROUTE_IDS.ORGANIZATION_BRANCHES_DETAIL,
    ROUTE_IDS.ORGANIZATION_BRANCHES_EDIT,
]);
function supportsPersonaFamily(route, personas) {
    if (route.authentication === 'public')
        return true;
    return route.allowedPersonas?.some((persona) => personas.has(persona)) ?? false;
}
/**
 * Build-time route manifest selector.
 *
 * Backend authorization remains authoritative. This selector additionally
 * prevents a platform-only or organization-only web artifact from registering
 * routes owned exclusively by the other application plane. Organization Runtime
 * also omits Branch-management UI while retaining the governed auth switch API.
 */
export function filterRoutesForComposition(routes, composition) {
    if (composition === 'COMBINED')
        return [...routes];
    const family = composition === 'PLATFORM_CONTROL_PLANE'
        ? PLATFORM_PERSONAS
        : ORGANIZATION_PERSONAS;
    return routes.filter((route) => {
        if (!supportsPersonaFamily(route, family))
            return false;
        if (composition === 'ORGANIZATION_RUNTIME' &&
            ORGANIZATION_RUNTIME_HIDDEN_ROUTE_IDS.has(String(route.routeId))) {
            return false;
        }
        return true;
    });
}
export function routeSupportsPlatform(route) {
    return supportsPersonaFamily(route, PLATFORM_PERSONAS);
}
export function routeSupportsOrganization(route) {
    return supportsPersonaFamily(route, ORGANIZATION_PERSONAS);
}
